module.exports = __webpack_public_path__ + "static/media/auto-debit-payment2.d13dc3bf.svg";